export function fireTextToast(toast, icon, message) {
  return toast.fire({ icon, titleText: String(message) });
}
